var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.buttonCss,
    attrs: {
      "disabled": _vm.disabled,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('click')
      }
    }
  }, [(_vm.icon) ? _c('icon', {
    class: _vm.iconClass,
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d92e10","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/CommonButton.vue
// module id = 1928
// module chunks = 0